import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { getErrorText } from '../helpers/business';

function ErrorWrapper({ error, type, children }) {
  const { t } = useTranslation();

  const errorData = error.data;

  return children(getErrorText(t, errorData.errCode, type, errorData.params));
}

ErrorWrapper.propTypes = {
  error: PropTypes.object.isRequired,
  children: PropTypes.func.isRequired,
};

export default ErrorWrapper;
